var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SessionModal',{attrs:{"modal":_vm.settingsModalData},on:{"setTab":_vm.setTab,"closeModal":_vm.toggleSettings}},[_c(_vm.selectedTab.component,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }